import { routes } from 'config';
import { actionTypes } from 'domain/notifications';

export const VNM_TERMS_MODAL = 'vnmTermsModal';
export const UTILITY_SYNC_POP_UP = 'UtilitySyncPopUp';
export const TURN_OFF_AUTO_PAY = 'turnOffAutoPay';
export const INVALID_PROOF_DOC = 'invalid_proof_doc';

export const mapLocation = (
  actionType: string,
  utilityAccountId: number | undefined
): string | undefined => {
  const {
    moving,
    payment,
    utilitySync,
    advocacy,
    membership,
    checkLmiEligibility,
  } = routes({
    utilityAccountId,
  });

  const locationMapper: Record<string, string | undefined> = {
    [actionTypes.moveRequest]: moving,
    [actionTypes.vnmTerms]: VNM_TERMS_MODAL,
    [actionTypes.paymentMethod]: payment,
    [actionTypes.utilityCredential]: utilitySync,
    [actionTypes.advocacy]: advocacy,
    [actionTypes.ipaTerms]: VNM_TERMS_MODAL,
    [actionTypes.goToMembership]: membership,
    [actionTypes.utilityCredentialPopUp]: UTILITY_SYNC_POP_UP,
    [actionTypes.noAction]: undefined,
    [actionTypes.turnOffAutoPay]: TURN_OFF_AUTO_PAY,
    [actionTypes.checkLmiEligibility]: checkLmiEligibility,
  };
  return locationMapper[actionType];
};

export const shouldDismissOnClick = (actionType: string): boolean =>
  actionType === actionTypes.advocacy ||
  actionType === actionTypes.turnOffAutoPay;
